<template>
  <a-card :bordered="false">
    <!-- 左サイドパネル -->
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
        <a-row :gutter="24">
          <a-col :sm="24" :md="8" :lg="8" :xl="6" :xxl="5">
            <a-form-model-item label="关键字">
              <a-input
                :placeholder="$t('disp.ph.matchOr', [$t('disp.dictCode'), $t('disp.dictName')])"
                v-model="queryParam.dictName"
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :xs="1" :sm="1" class="width-fit-content">
            <a-form-model-item :wrapperCol="{ span: 24 }">
              <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                $t('disp.btn.search')
              }}</a-button>
              <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <div class="table-operator" style="border-top: 5px">
      <a-button type="primary" @click="handleAdd" icon="plus">{{ $t('disp.btn.add') }}</a-button>
      <a-button type="primary" @click="refleshCache()" icon="sync">刷新缓存</a-button>
    </div>

    <a-table
      ref="table"
      class="action"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <span slot="rowIndex" slot-scope="text, record, index">
        {{ (ipagination.current - 1) * ipagination.pageSize + parseInt(index) + 1 }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
        <a-divider type="vertical" />
        <a @click="editDictItem(record)">{{ $t('disp.editDictItem') }}</a>
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
          <a>{{ $t('disp.btn.delete') }}</a>
        </a-popconfirm>
      </span>
    </a-table>
    <!-- 汎用情報の編集 -->
    <dict-modal ref="modalForm" @ok="modalFormOk"></dict-modal>
    <!-- 汎用情報の配置 -->
    <dict-item-list ref="dictItemList"></dict-item-list>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { ajaxGetDictItems } from '@/api/api'
import { tableMixin } from '@/mixins/tableMixin'
import DictModal from './modules/DictModal'
import DictItemList from './DictItemList'
import { getAction } from '@/api/manage'

export default {
  name: 'DictManage',
  mixins: [tableMixin],
  components: { DictModal, DictItemList },
  data() {
    return {
      description: '字典管理',
      visible: false,
      // クエリ条件
      queryParam: {
        dictName: '',
      },
      // テーブルタイトル
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 47,
          align: 'center',
          scopedSlots: { customRender: 'rowIndex' },
        },
        {
          title: this.$t('disp.dictName'),
          align: 'left',
          dataIndex: 'dictName',
        },
        {
          title: this.$t('disp.dictCode'),
          align: 'left',
          dataIndex: 'dictCode',
        },
        {
          title: this.$t('disp.note'),
          align: 'left',
          dataIndex: 'description',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      dict: '',
      url: {
        list: '/blaze-sys//k00/k0006/DictManage/list',
        delete: '/blaze-sys//k00/k0006/DictManage/delete',
        refleshCache: '/blaze-sys//k00/k0006/DictManage/refleshCache',
      },
    }
  },
  methods: {
    // 汎用情報を編集
    editDictItem(record) {
      this.$refs.dictItemList.edit(record)
    },
    // 定数サーチインプットの内容をリセットする
    searchReset() {
      this.queryParam.dictName = ''
    },
    refleshCache() {
      getAction(this.url.refleshCache).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('msg.operation.success'))
          this.$getDict(null, null, true)
        }
      })
    },
  },
}
</script>
<style scoped></style>
